import { useEffect } from 'react'
import { ROUTES } from '@zing/shared/constants'
import { useSmartNavigate } from '@zing/shared/smartNav/useSmartNavigate'

// Tenant zing (app.zinginnovation.com): used by Hotsite block routes that
// aren't in the allowlist — redirects to /login via useSmartNavigate (not
// useNavigate/Navigate directly) to respect the same shell-vs-legacy
// decision as the rest of the navigation.
export const ZingHotsiteRedirect = (): JSX.Element => {
  const navigate = useSmartNavigate()

  useEffect(() => {
    navigate(ROUTES.USER_AUTH.LOGIN, { replace: true })
  }, [])

  return <div />
}

export default ZingHotsiteRedirect
